import DragController from 'components/drag-controller/DragController';
import scroll from 'core/scroll';
import { bindEmitterMethod } from 'helpers/bind';
import { clamp } from 'lodash-es';
import Component from 'navigation/component/Component';
export default class EditorialSubnav extends Component {
    endOfPage;
    getModulesMap() {
        return {
            dragController: ['.editorial-subnav__title', DragController]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            gradient: true
        };
    }
    initialized() {
        super.initialized();
    }
    bindEvents(add) {
        const emitterMethod = bindEmitterMethod(add);
        scroll.emitter[emitterMethod]('scroll', () => this.updateScrollbar());
    }
    updateScrollbar = () => {
        this.refs.subnavInnerTrack.style.transform = `scaleX(${clamp((scroll.scrollTop() / (this.endOfPage - 300)) * 100, 0, 100)}%)`;
    };
    resize() {
        super.resize();
        this.updateScrollbar();
    }
}
